import { render } from "./pie-v3.vue?vue&type=template&id=52e6d1d4&scoped=true"
import script from "./pie-v3.vue?vue&type=script&lang=js"
export * from "./pie-v3.vue?vue&type=script&lang=js"

import "./pie-v3.vue?vue&type=style&index=0&id=52e6d1d4&lang=scss&scoped=true"

import exportComponent from "/Users/jigarpyunt/Desktop/ArrowDT/Git/SDB/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52e6d1d4"]])

export default __exports__